import React, { useContext } from 'react'
import 'stylesheets/TimerAppStyles/TodoCounter.css'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext';

const TodoCounter = () => {

    const {completedTodos, totalTodos} = useContext(TodoContext);
    return (
        <h2 className='todo-counter-h2'>Haz completado {completedTodos} de {totalTodos} TO-DO's</h2>
    )
}

export { TodoCounter }